import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "token",
  initialState: {
    uid: "",
  },
  reducers: {
    setUID: (state, action: PayloadAction<string>) => {
      state.uid = action.payload;
    },
  },
});

export const { setUID } = userSlice.actions;

export default userSlice.reducer;
